/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconSimple/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconSimple({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconSimple",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 11,
  height = 20,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#030E12"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconSimple.Svg"
  data-view-path={viewPath}
 viewBox="0 0 11 20"
 style={{'--as-1-1xfpDs': alignSelf,'--mt-2-1xfpDs': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1xfpDs': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1xfpDs': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1xfpDs': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1xfpDs': opacity,'--w-10-1xfpDs': typeof width === 'number' ? `${width}px` : width,'--h-11-1xfpDs': typeof height === 'number' ? `${height}px` : height,'--f-12-1xfpDs': fill,'--a-7-1xfpDs': isAnimated ? animation : "none",'--sd-8-1xfpDs': isAnimated ? strokeDashoffset : 0,'--sd-9-1xfpDs': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconSimple.SvgPath"
  data-view-path={viewPath}
 d="M7.844 12.945c0-.282-.044-.53-.133-.747a1.423 1.423 0 00-.448-.597c-.21-.178-.503-.346-.88-.507a12.29 12.29 0 00-1.41-.49 12.969 12.969 0 01-1.62-.589 5.654 5.654 0 01-1.236-.755 2.98 2.98 0 01-.789-.971 2.766 2.766 0 01-.274-1.254 2.94 2.94 0 011.12-2.34c.366-.3.8-.532 1.304-.698a5.362 5.362 0 011.685-.249c.908 0 1.677.174 2.308.523.636.343 1.12.794 1.452 1.353.332.553.498 1.146.498 1.776H7.828c0-.453-.097-.855-.29-1.203a2.001 2.001 0 00-.88-.83c-.394-.205-.892-.307-1.495-.307-.57 0-1.04.085-1.411.257-.37.171-.648.404-.83.697a1.905 1.905 0 00-.266 1.005c0 .254.053.487.158.697.11.205.28.395.506.573.233.177.526.34.88.49.36.149.789.293 1.287.431.686.194 1.278.41 1.776.647.498.238.908.507 1.229.806.326.293.567.628.722 1.004.16.37.24.791.24 1.262 0 .492-.099.938-.298 1.336-.2.399-.484.739-.855 1.021-.371.282-.816.5-1.337.656-.514.15-1.09.224-1.726.224-.56 0-1.11-.078-1.652-.232a4.924 4.924 0 01-1.47-.698 3.653 3.653 0 01-1.054-1.145c-.26-.46-.39-.99-.39-1.594h1.594c0 .415.08.772.24 1.07.161.294.38.538.657.731.282.194.6.338.954.432.36.088.733.133 1.12.133.56 0 1.033-.078 1.42-.233.388-.155.68-.376.88-.664.205-.287.307-.628.307-1.02z"
 style={{'--f-12-1xfpDs': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
<path
  data-testid="TysiaIconSimple.SvgPath:1"
  data-view-path={viewPath}
 d="M7.875 7.356c0 .283-.044.533-.133.75a1.429 1.429 0 01-.45.6c-.211.177-.506.347-.884.508-.372.161-.844.325-1.416.492-.6.177-1.142.375-1.625.591-.484.223-1.423.642-1.767.925-.344.284-.55.442-.733.809-.184.366-.192.419-.192.891 0 .473.48 1.275.675 1.675.194.4.414.264.775.559.367.3.736.5 1.242.666.505.167 1.194.242 1.816.242.911 0 1.65-.025 2.284-.375.639-.345 1.158-.422 1.491-.983.334-.556.5-1.15.5-1.784h-1.6c0 .456-.097.859-.291 1.209a2.01 2.01 0 01-.884.833c-.394.205-.894.308-1.5.308-.572 0-1.044-.086-1.416-.258-.373-.172-.65-.406-.834-.7-.177-.294-.658-.78-.658-1.158 0-.256.136-.456.242-.667.11-.206.389-.28.616-.458.234-.178.445-.259.8-.409.361-.15.825-.394 1.325-.533.69-.194 1.534-.395 2.034-.633.5-.24.91-.509 1.233-.809.328-.294.57-.63.725-1.008.161-.372.208-.811.208-1.283 0-.495-.066-.925-.266-1.325-.2-.4-.486-.742-.859-1.025a4.146 4.146 0 00-1.341-.659 6.21 6.21 0 00-1.734-.225c-.56 0-1.114.078-1.658.234a4.942 4.942 0 00-1.475.7c-.439.31-.592.644-.858 1.1-.261.46 0 1.06 0 1.666l1.466-.016c0-.417-.377-.775-.216-1.075.16-.295.139-.781.416-.975.284-.195.645-.506 1-.6.361-.09.861-.15 1.25-.15.561 0 1.42.26 1.809.416.389.156.608.578.808.867.206.289.075.672.075 1.067z"
 fillOpacity=".25"
 style={{'--f-12-1xfpDs': fill2}}
 className={`views-block ${styles.SvgPath1}`}
/>
</svg>
{children}
</React.Fragment>)
}